import React from 'react';

const NotificationSettings: React.FC = () => {
  return <div>Notification Settings</div>;
};

export default NotificationSettings;